/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_Select from "../../components/BSL_Select";
import BSL_ColourSelector from "../../components/BSL_ColourSelector";
import BSL_TextInput from "../../components/BSL_TextInput";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import { updateAreaSpecificationGutterDownpipe } from "../../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";

import BSL_CheckBox from "../../components/BSL_CheckBox";

const useStyles = makeStyles({
    root: {
        // background: "#D9E1E5",
        // maxWidth: '400px',
        // minWidth: '30px',
        padding: "0px 8px 8px 8px",
    },
    cutoutSummary: {
        color: "white",
        fontSize: "70%",
    },
    paper_root: {
        background: "#090909ad",
    },
});

export default function SpecGutterDownpipeTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    // const [password, setPassword] = React.useState("");
    const { areaIndex } = props;
    const user = useSelector((state) => state.app?.user);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];

    

    const GutterDownpipeParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES];
    const carportMode = job?.DesignParameters?.CarportMode === 1;
    const designType = carportMode ? "National Carport" : area_design_specs.SHAPE.DesignType;
    const area_config = config?.design_options?.[designType];
    const app = useSelector((state) => state.app);

    const updateGutterDownpipeData =
        (dataField) =>
            (event, value = null) => {
                if (value === null) value = event?.target?.value ? event?.target?.value : event;
                if (value?.props?.value) value = value.props.value;

                let error = dispatch(updateAreaSpecificationGutterDownpipe(areaIndex, null, dataField, value));
                if (error && error.error) {
                    dispatch(APP.showDialogData(error));
                }
                return;
            };

    let gutter_menu_items = [];
    const this_gutter = config?.gutter_types?.[GutterDownpipeParameters.GutterType];

    if (area_config?.gutter_options)
        for (let key of area_config?.gutter_options) {
            var gutter = config.gutter_types[key];
            if (gutter) {
                gutter_menu_items.push({
                    Key: key,
                    Display: gutter[CONFIG.GUTTER_TYPE.NAME],
                    Thumbnail: gutter[CONFIG.GUTTER_TYPE.THUMBNAIL],
                });
            }
        }

    let downpipe_menu_items = [];
    const this_downpipe = config?.downpipe_types?.[GutterDownpipeParameters.DownpipeType];

    if (area_config?.downpipe_options)
        for (let key of area_config?.downpipe_options) {
            var downpipe = config.downpipe_types[key];
            if (downpipe)
                downpipe_menu_items.push({
                    Key: key,
                    Display: downpipe[CONFIG.DOWNPIPE_TYPE.NAME],
                    Thumbnail: downpipe[CONFIG.DOWNPIPE_TYPE.THUMBNAIL],
                });
        }

    let fascia_colour = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.BeamCol1;
    let edge_beam_colour = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.BeamCol3;
    let gutter_colour = GutterDownpipeParameters?.GutterCol;
    let colourMatch = {
        "Match Fascia": fascia_colour,
        "Match Gutter": gutter_colour,
        "Match Edge Beam": edge_beam_colour,
    };

    
    
    

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                {carportMode && (
                    <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>Gutters</BSL_Common.SectionHeader>
                )}
                <BSL_Common.SectionRow>
                    <BSL_Select
                        style={{ flex: 1 }}
                        value={GutterDownpipeParameters.GutterType}
                        tight={true}
                        items={gutter_menu_items}
                        onChange={updateGutterDownpipeData("GutterType")}
                    />
                    <BSL_ColourSelector
                        tight
                        colourList={["TBA", this_gutter[CONFIG.GUTTER_TYPE.COLOURS]]}
                        value={GutterDownpipeParameters.GutterCol}
                        onChange={updateGutterDownpipeData("GutterCol")}
                    />
                </BSL_Common.SectionRow>
                {!carportMode && (
                    <>
                        <BSL_Common.SectionHeader>Box Gutter</BSL_Common.SectionHeader>
                        <BSL_Common.SectionRow>
                            {/* <BSL_TextInput
                        label="Width"
                        value={GutterDownpipeParameters.BoxGutterWidth}
                        tight
                        min={0}
                        max={500}
                        endAdornment="mm"
                        onBlur={updateGutterDownpipeData("BoxGutterWidth")}
                        style={{
                            maxWidth: "100px",
                        }}
                    /> */}
                            <BSL_Select
                                label="Width"
                                style={{ maxWidth: "100px" }}
                                value={GutterDownpipeParameters.BoxGutterWidth}
                                tight={true}
                                items={[
                                    {
                                        Key: 200,
                                        Display: "200 mm",
                                    },
                                    {
                                        Key: 230,
                                        Display: "230 mm",
                                    },
                                    {
                                        Key: 260,
                                        Display: "260 mm",
                                    },
                                ]}
                                onChange={updateGutterDownpipeData("BoxGutterWidth")}
                            />
                            <BSL_ColourSelector
                                tight
                                label="Colour"
                                colourMatch={colourMatch}
                                colourList={[
                                    "Match Fascia",
                                    "Match Gutter",
                                    "Match Edge Beam",
                                    config.colour_arrays["Colorbond & Zincalume"],
                                ]}
                                value={GutterDownpipeParameters.BoxGutterColourMatchBeam}
                                onChange={updateGutterDownpipeData("BoxGutterColourMatchBeam")}
                            />
                        </BSL_Common.SectionRow>
                    </>
                )}
                <BSL_Common.SectionHeader>Downpipes</BSL_Common.SectionHeader>
                <BSL_Common.SectionRow>
                    <BSL_Select
                        style={{ flex: 1 }}
                        value={GutterDownpipeParameters.DownpipeType}
                        tight={true}
                        items={downpipe_menu_items}
                        onChange={updateGutterDownpipeData("DownpipeType")}
                        disabled={carportMode}
                    />
                    <BSL_ColourSelector
                        tight
                        colourList={["TBA", this_downpipe?.[CONFIG.DOWNPIPE_TYPE.COLOURS]]}
                        value={GutterDownpipeParameters.DownpipeCol}
                        onChange={updateGutterDownpipeData("DownpipeCol")}
                    />
                </BSL_Common.SectionRow>
                <BSL_CheckBox
                    tight
                    checked={GutterDownpipeParameters.AddAutomaticDownpipes}
                    returnInt
                    label={<span style={{ whiteSpace: "nowrap" }}>{carportMode ? "Add Downpipe" : "Automatically Add Downpipes"}</span>}
                    onChange={updateGutterDownpipeData("AddAutomaticDownpipes")}
                    style={{
                        marginTop: "-12px",
                    }}
                />
                {/* <BSL_Common.SectionRow>
                    <SegmentedButtonGroup
                        label="Material"
                        tight
                        value={RoofSheetParameters.RoofSubType}
                        items={sheet_menu_sub_items}
                        onChange={updateRoofData("RoofSubType")}
                        style={{
                            marginTop: '-12px',
                        }}
                    />
                    <SegmentedButtonGroup
                        label="Span Allowance"
                        tight
                        value={RoofSheetParameters.RoofSpan}
                        items={span_items}
                        onChange={updateRoofData("RoofSpan")}
                        style={{
                            marginTop: '-12px',
                        }}
                    />
                </BSL_Common.SectionRow> */}
            </BSL_Common.SectionContainer>
        </div>
    );
}
